import Icon from 'components/Icon';

export type FileIconProps = {
  type: string | null;
};

const iconMap: Record<string, { name: string; color: string }> = {
  image: { name: 'image-file', color: '#80B8F1' },
  video: { name: 'video-file', color: '#80B8F1' },
  audio: { name: 'audio-file-speaker', color: '#80B8F1' },
  webapp: { name: 'file-code', color: '#80B8F1' },
  youtube: { name: 'file-youtube', color: '#EA3323' },
  vimeo: { name: 'file-vimeo', color: '#4EABEA' },
  pdf: { name: 'pdf-file', color: '#D75C44' },
  doc: { name: 'doc-file', color: '#5986DD' },
  ppt: { name: 'ppt-file', color: '#EC7D4F' },
  xls: { name: 'xls-file', color: '#479B5F' },
  whiteboard: { name: 'whiteboard-file', color: '#80B8F1' },
  shared: { name: 'folder-person', color: '#65A3E4' },
};

const defaultIcon = { name: 'file', color: '#80B8F1' };
const folderIcon = { name: 'folder', color: '#65A3E4' };

const FileIcon = ({ type }: FileIconProps) => {
  const iconDetails = type === null ? folderIcon : iconMap[type] || defaultIcon;

  return (
    <Icon
      name={iconDetails.name}
      sx={{
        fontSize: 32,
        color: iconDetails.color,
      }}
    />
  );
};

export default FileIcon;
